import { Pencil } from 'lucide-react';
import type { ReactNode, Ref } from 'react';

import { NeedsDetailsPill } from './NeedsDetailsPill';

export function EditSectionHeader({
  id,
  title,
  hint,
  action,
  unsaved,
  canEdit,
  editLabel,
  editRef,
  onEdit,
}: {
  id: string;
  title: string;
  hint?: string;
  action?: ReactNode;
  unsaved: boolean;
  canEdit: boolean;
  editLabel?: string;
  editRef?: Ref<HTMLButtonElement>;
  onEdit: () => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 10,
        paddingBottom: 7,
        borderBottom: '1px solid var(--nb-border)',
      }}
    >
      <h3
        id={id}
        className="nb-display"
        style={{ margin: 0, fontSize: 13, letterSpacing: '.04em' }}
      >
        {title}
      </h3>
      {hint && <span style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>{hint}</span>}
      {unsaved && <NeedsDetailsPill />}
      <span style={{ flex: 1 }} />
      {action}
      {canEdit && (
        <button
          ref={editRef}
          type="button"
          aria-label={editLabel}
          className="nb-btn nb-btn-ghost"
          onClick={onEdit}
          style={{ height: 24, fontSize: 11, padding: '0 8px' }}
        >
          <Pencil size={11} />
          Edit
        </button>
      )}
    </div>
  );
}
